export default __webpack_public_path__ + "static/media/Personaje-Banner2.7cb4d78c.png";